import { AxiosResponse } from "axios";
import { deleteAsync, getAsync, postAsync, putAsync } from "./client";
import { Group } from "../@type/group";

class GroupService {
  get = async (): Promise<AxiosResponse> => {
    try {
      const response = await getAsync('groups');
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; 
    }
  }
  getById = async (groupId:number): Promise<AxiosResponse> => {
    return await getAsync(`groups/${groupId}`)
  }

  post = async (groupData: Group): Promise<AxiosResponse> => {
    return await postAsync('groups',groupData);
  }

  delete = async (id:number): Promise<AxiosResponse> => {
    return await deleteAsync(`groups/${id}`);
  }

  updateById = async (id: number, data: Group): Promise<AxiosResponse> => {
      return await putAsync(`groups/${id}`, data);
    };
  
}

const groupService = new GroupService();

export default groupService;
